import React from "react";
import { Routes, Route } from "react-router-dom";
import PathwayRedirect from "../PathwayRedirect";
import NotFound from "../NotFound";

export default function PathwaysRouter() {
  return (
    <Routes>
      <Route path=":id" element={<PathwayRedirect />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
